<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" :title="title">
          <div slot="content">
            <div class="form-group col-md-12 col-sm-12 col-xs-12">
              <label>Bật/tắt tính năng quản lý số</label>
              <b-form-checkbox v-model="company.enable_phone_number_management" switch size="lg"></b-form-checkbox>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorCompanyName ? 'has-error' : ''">
              <label>Tên doanh nghiệp<span class="error-symbol"></span></label>
              <input id="companyName" type="text" class="form-control" v-model="company.name"
                     placeholder="Nhập tên doanh nghiệp..."/>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorType ? 'has-error' : ''">
              <label>Ngành hàng<span class="error-symbol"></span></label>
              <input type="text" class="form-control" v-model="company.type" placeholder="Nhập ngành hàng ..."/>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorOwner ? 'has-error' : ''">
              <label>Chủ doanh nghiệp<span class="error-symbol"></span></label>
              <input type="text" class="form-control" v-model="company.owner"
                     placeholder="Nhập chủ doanh nghiệp ..."/>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorPhone ? 'has-error' : ''">
              <label>SĐT Doanh nghiệp<span class="error-symbol"></span></label>
              <input type="text" class="form-control" v-model="company.phone"
                     placeholder="Nhập SĐT Doanh nghiệp ..."/>
              <span class="help-block" v-show="errorPhone">Số điện thoại không hợp lệ</span>
            </div>
          </div>
          <div slot="footer">
            <div class="pull-right">
              <b-button variant="success" class="w-100px" @click="save">Lưu</b-button>
              <b-button variant="warning" class="w-100px" @click="back">Trờ về</b-button>
            </div>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import CompanyAPI from '../../../api/company'
import Utils from '../../../common/utils'
import {ERROR_CODE} from '../../../common/constant'
import {MESSAGE} from '../../../common/message'

export default {
  name: 'CompanyDetail',
  components: {
    'va-box': VABox,
  },
  data () {
    return {
      company: {
        id: null,
        name: '',
        type: '',
        owner: '',
        phone: '',
      },
      loading: false,
      saving: false,
      click: false,
      title: ''
    }
  },
  computed: {
    errorCompanyName: function () {
      return this.isEmpty(this.company.name)
    },
    errorType: function () {
      return this.isEmpty(this.company.type)
    },
    errorOwner: function () {
      return this.isEmpty(this.company.owner)
    },
    errorPhone: function () {
      return this.isEmpty(this.company.phone) || (this.click && !Utils.phoneNumberCheck(this.company.phone))
    },
  },
  mounted () {
    this.init()
    this.title = this.isEdit() ? 'Cập nhật doanh nghiệp' : 'Thêm doanh nghiệp mới'
  },
  methods: {
    validate () {
      return !this.errorCompanyName && !this.errorPhone && !this.errorType && !this.errorOwner
    },
    isEmpty (value) {
      return (this.click && (value == null || value.length <= 0))
    },
    isEdit () {
      return !!this.$route.params.id
    },
    init () {
      this.getCompanyDetail()
    },
    async getCompanyDetail () {
      this.loading = true
      const id = this.$route.params.id
      if (id) {
        try {
          this.company = (await CompanyAPI.findById(id)).data.data
          this.loading = false
        } catch (err) {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        }
      }
      return null
    },
    back () {
      this.$router.push({name: 'CompanyList'})
    },
    save () {
      this.click = true
      this.saving = true
      this.loading = true
      if (!this.validate()) {
        this.saving = false
        this.loading = false
        return
      }
      const id = this.$route.params.id

      if (id) {
        CompanyAPI.update(this.company).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            Utils.successToast(this.$bvToast)
          }
        }).catch(err => {
          this.loading = false
          if (err.response.status === 400) {
            this.errorMsg = ERROR_CODE[err.response.data.code]
            Utils.failedToast(this.$bvToast, MESSAGE.SERVER_ERROR, ERROR_CODE[err.response.data.code])
          }
        })
      } else {
        CompanyAPI.create(this.company).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            Utils.successToast(this.$bvToast)
            this.back()
          }
        }).catch(err => {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user_management/company/CompanyDetail.vue